import {
    DatePicker,
    MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/moment";
import {
    modifyFilterValue,
    selectFiltersValueDate,
    loadFiltersAsync,
    refreshFiltersValue,
    selectFiltersValue,
    selectFiltersData,
    selectFiltersValueZones,
    defaultFiltersValue
} from "./filterSlice";
import {useDispatch, useSelector} from "react-redux";
import "moment/locale/ru";
import styles from '../../cleaning/filter/FilterPanel.module.css';
import {Button, Col, Form, FormCheck, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter, faRefresh} from "@fortawesome/free-solid-svg-icons";
import RightPanel from "../../panel/RightPanel";
import {useEffect, useState} from "react";
import moment from "moment";
import {useCity} from "../../../app/utils/use";
import Select from "react-select";
import _ from 'lodash'
import FormCheckInput from "react-bootstrap/FormCheckInput";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

const FilterPanel = ({onApply, onShowCleaners}) => {

    const dispatch = useDispatch();

    const dateInValue = useSelector(selectFiltersValueDate);
    const filtersValue = useSelector(selectFiltersValue);
    const filtersData = useSelector(selectFiltersData);
    const zonesInValue = useSelector(selectFiltersValueZones);
    const cityId = useCity();

    const [filterVersion, updateFilterVersion] = useState(moment().valueOf());
    const [filtersIsOpen, setFiltersIsOpen] = useState(false);
    const [filterApplied, setFilterApplied] = useState(false);
    const [filterCleanersByType, setFilterCleanersByType] = useState(null);
    const [countAppliedFilters, setCountAppliedFilters] = useState(0);

    useEffect(() => {
        dispatch(loadFiltersAsync({cityId: cityId, date: filtersValue.date}));
        dispatch(refreshFiltersValue());
        updateFilterVersion(moment().valueOf());
        onApply(filtersValue);
    }, [cityId]);

    useEffect(() => {
        onShowCleaners(filterCleanersByType);
    }, [filterCleanersByType]);

    useEffect(() => {
        let countFilters = 0;
        _.each(defaultFiltersValue, (defaultFilterValue, key) => {
            if (key !== 'date' && !_.isEqual(defaultFilterValue, filtersValue[key])) {
                countFilters++;
            }
        });
        setCountAppliedFilters(countFilters);
    }, [filtersValue]);

    useEffect(() => {
        if (filterApplied === true) {
            onApply(filtersValue);
            setFilterApplied(false);
        }
    }, [filterApplied]);

    const zonesArray = Array.isArray(filtersData.zones)
        ? filtersData.zones
        : _.flatten(_.values(filtersData.zones || {}));
    const allZoneIds = _.map(zonesArray, 'zoneId');

    return (
        <div className={styles.FilterPanelWrap} key={filterVersion}>
            <div className={styles.DateWrap}>
                <Row>
                    <Col md={2}>
                        <Button variant={"success"} onClick={() => onApply(filtersValue)} size={'sm'}>
                            <FontAwesomeIcon icon={faRefresh}/>
                        </Button>
                    </Col>
                    <Col md={10} style={{"paddingTop": "10px"}}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={'ru'}>
                            <DatePicker
                                value={dateInValue}
                                onChange={(date) => {
                                    dispatch(loadFiltersAsync({cityId: cityId, date: date.format('YYYY-MM-DD')}));
                                    dispatch(refreshFiltersValue());
                                    updateFilterVersion(moment().valueOf());
                                    dispatch(modifyFilterValue({
                                        key: 'date',
                                        value: date.format('YYYY-MM-DD')
                                    }));
                                    setFilterApplied(true);
                                }}
                                disableToolbar
                                autoOk
                                variant={'inline'}
                                format={'YYYY-MM-DD'}
                            />
                        </MuiPickersUtilsProvider>
                    </Col>
                </Row>
            </div>
            <div className={styles.FiltersBtn}
                 onClick={() => setFiltersIsOpen(true)}>
                <FontAwesomeIcon icon={faFilter}/> Фильтры
                {countAppliedFilters ? <span className={styles.CountAppliedFilters}>{countAppliedFilters}</span> : null}
            </div>
            <div className={styles.FiltersWrap}>
                <RightPanel width={'100%'} height={"88vh"} isOpen={filtersIsOpen}>
                    <div className={styles.ActionBlock}>
                        <Row>
                            <Col md={5} style={{"paddingRight": 0}}>
                                <div className={styles.FiltersBtnInWrap}
                                     onClick={() => setFiltersIsOpen(false)}>
                                    <FontAwesomeIcon icon={faFilter}/> Фильтры
                                </div>
                            </Col>
                            <Col md={3} style={{"padding": 0}}>
                                <Button variant={'danger'}
                                        onClick={() => {
                                            dispatch(refreshFiltersValue());
                                            updateFilterVersion(moment().valueOf());
                                            setFilterApplied(true);
                                        }}
                                        size={'sm'}>Сбросить</Button>
                            </Col>
                            <Col md={3} style={{"padding": 0}}>
                                <Button variant={'success'}
                                        onClick={() => setFilterApplied(true)}
                                        size={'sm'}>Применить</Button>
                            </Col>
                        </Row>
                    </div>
                    <label><h6>Выездные мастера</h6></label>
                    <Select
                        options={(Array.isArray(filtersData.onsiteDrycleaners) ? filtersData.onsiteDrycleaners : _.values(filtersData.onsiteDrycleaners || {})).map((cleaner) => ({
                            value: cleaner.id,
                            label: cleaner.name,
                            id: cleaner.id
                        }))}
                        onChange={(value) => dispatch(modifyFilterValue({
                            key: 'onsiteDrycleanerNumber', value: value.id
                        }))}
                    />
                    <label><h6>Домашние адреса мастеров</h6></label>
                    <Row style={{marginRight: 0}}>
                        <Col md={6} style={{"paddingRight": 0}}>
                            <FormCheck
                                checked={filterCleanersByType === 1}
                                onChange={(e) => {
                                    setFilterCleanersByType(e.target.checked ? 1 : null);
                                }}
                                inline label={"Все мастера"}/>
                        </Col>
                        <Col md={6} style={{"paddingRight": 0}}>
                            <FormCheck
                                checked={filterCleanersByType === 2}
                                onChange={(e) => {
                                    setFilterCleanersByType(e.target.checked ? 2 : null);
                                }}
                                inline label={"Активные"}/>
                        </Col>
                    </Row>
                    <hr style={{'margin': '5px 0'}}/>
                    <label>Номер заказа</label>
                    <Form.Control
                        type="text"
                        placeholder="Введите номер заказа"
                        value={filtersValue.orderNumber || ''}
                        onChange={(e) => dispatch(modifyFilterValue({
                            key: 'orderNumber', value: e.target.value || null
                        }))}
                    />
                    <label>Статус</label>
                    <Select
                        options={_.map(filtersData.statuses, (status, id) => ({
                            value: status, label: status, id: parseInt(id)
                        }))}
                        onChange={(value) => dispatch(modifyFilterValue({
                            key: 'status', value: value.id
                        }))}
                    />
                    <label>Рабочие зоны</label>
                    <div className={styles.ZonesWrap}>
                        <FormCheck inline>
                            <FormCheckInput onChange={(e) => {
                                dispatch(modifyFilterValue({
                                    key: 'zones',
                                    value: allZoneIds,
                                    strategy: e.target.checked ? 'union' : 'without'
                                }));
                            }}/>
                            <FormCheckLabel>Все зоны</FormCheckLabel>
                        </FormCheck>
                        <Row style={{marginRight: 0}}>
                            {zonesArray.map((zone) => (
                                <Col md={6} style={{"paddingRight": 0}} key={'zone-' + zone.zoneId}>
                                    <FormCheck
                                        inline
                                        label={zone.shortName || zone.name}
                                        checked={_.includes(zonesInValue, zone.zoneId)}
                                        onChange={(e) => {
                                            dispatch(modifyFilterValue({
                                                key: 'zones',
                                                value: e.target.checked ? [zone.zoneId] : zone.zoneId,
                                                strategy: e.target.checked ? 'union' : 'without'
                                            }));
                                        }}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </div>
                </RightPanel>
            </div>
        </div>
    );
};

export default FilterPanel;
